import { PageHeader } from "@sylviq/ui-react-web/components/ui/page-header";
import { TaxEstimatesTab } from "@/features/tax/TaxEstimatesTab";

export function TaxEstimatesPage() {
  return (
    <div className="grid gap-6">
      <PageHeader
        title="Tax estimates"
        description="Manual pricing and reserve models: you supply the amount, rate, and source. Nothing is filed, and no payment is sent."
      />
      <TaxEstimatesTab />
    </div>
  );
}
